import React, { useEffect, useState } from 'react';
import { dynamoDb } from '../../awsConfig'; 
import { useAuth } from '../AuthContext/authContext'; 
import './ZoomLink.css'
const ZoomLink = () => {
  const { user } = useAuth(); 
  const [zoomLink, setZoomLink] = useState('');
  const [newLink, setNewLink] = useState('');
  const [loading, setLoading] = useState(true);

  // Fetch the Zoom link from DynamoDB
  const fetchZoomLink = async () => {
    const params = {
      TableName: 'videos2', 
      Key: {
        Date: "zoomLink", 
        Subject: "zoomLink", 
      },
    };

    try {
      const result = await dynamoDb.get(params).promise();
      return result.Item?.url || 'Meeting has not started yet';
    } catch (error) {
      console.error('Error fetching Zoom link:', error);
      return 'Error fetching Zoom link';
    }
  };

  // Save the Zoom link to DynamoDB
  const saveZoomLink = async (zoomLink) => {
    const params = {
      TableName: 'videos2', 
      Key: {
        Date: "zoomLink", 
        Subject: "zoomLink", 
      },
      UpdateExpression: 'set #url = :url',
      ExpressionAttributeNames: {
        '#url': 'url',
      },
      ExpressionAttributeValues: {
        ':url': zoomLink,
      },
    };

    try {
      await dynamoDb.update(params).promise();
      console.log('Zoom link updated successfully');
    } catch (error) {
      console.error('Error saving Zoom link:', error);
      throw new Error('Error saving Zoom link');
    }
  };

  // Load the Zoom link when the component mounts
  useEffect(() => {
    const loadZoomLink = async () => {
      try {
        const link = await fetchZoomLink();
        setZoomLink(link);
      } catch (error) {
        console.error('Error loading Zoom link:', error);
      } finally {
        setLoading(false);
      }
    };
    loadZoomLink();
  }, []);

  // Handle saving the Zoom link
  const handleSave = async () => {
    if (!newLink) {
      alert('Please enter a valid Zoom link');
      return;
    }
    try {
      await saveZoomLink(newLink);
      setZoomLink(newLink);
      setNewLink('');
      alert('Zoom link updated successfully');
    } catch (error) {
      console.error('Error saving Zoom link:', error);
      alert('Failed to save Zoom link');
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="zoom-link-container">
      <h2>Zoom Meeting Link</h2>
      {zoomLink !== 'Meeting has not started yet' ? (
        <p>
          <strong>Link:</strong>{' '}
          <a href={zoomLink} target="_blank" rel="noopener noreferrer">
            Join Meeting
          </a>
        </p>
      ) : (
        <p>{zoomLink}</p>
      )}

      {user?.role === 'Admin' || user?.role === 'Tutor' ? (
        <div className="zoom-link-admin">
          <h3>Update Zoom Link</h3>
          <input
            type="text"
            value={newLink}
            onChange={(e) => setNewLink(e.target.value)}
            placeholder="Enter new Zoom link"
          />
          <button onClick={handleSave}>Save</button>
        </div>
      ) : null}
    </div>
  );
};

export default ZoomLink;
